import React from 'react'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom';

type DriveCustomCardProps = {
	id: string;
	image: string;
	title: string;
	location: string;
	time: Date;
	isRegistered: boolean;
	totalParticipating: number;
};
const DriveCustomCard: React.FC<DriveCustomCardProps> = ({
  
    id,
    title,
    location,
    time,
    isRegistered,
    totalParticipating,}) => {
      const navigate = useNavigate();

    const date = dayjs(time).format('DD');
    const month = dayjs(time).format('MMM');

  return (
    <button 
      onClick={() => navigate(`/drive-form?drive=${encodeURIComponent(JSON.stringify([id]))}`)}
      className="w-[280px] flex flex-row flex-shrink-0 gap-[10px] rounded-[8px] border border-[#EBEBF0] bg-[#FFF] pb-[14px] pr-[34px] relative cursor-pointer">
      <div className="pl-[10px] relative">
        <img src="/assets/recruiterImages/driveDate.svg" alt="driveDate" />
        <p className='absolute top-[18%] left-[34%] text-[#FFF] text-center font-poppins text-[14px] font-[700] leading-[14px]'>
          {date}
          <br/>
          <span className='text-white text-center font-poppins text-[10px] font-[700] leading-[6px] tracking-[0.3px] uppercase'>
            {month}
            </span></p>
      </div>

      <div className="pt-[14px]">
        <div className="">
            <h1 className="text-[#1C1C28] font-inter text-[14px] font-[600] leading-[20px]">{title}</h1>
        </div>
        <div className="flex flex-row gap-[10px] mt-2">
            <div className="flex flex-col">
                <img className="w-[16px] h-[16px]" src="/assets/recruiterImages/drivetech.svg" alt="Tech and Non tech"  />
                <img className="w-[16px] h-[16px]" src="/assets/recruiterImages/driveCandidates.svg" alt="candidates"  />
            </div>
            <div className="text-[#555770] font-inter text-[12px] font-[400] leading-[16px]">
                <p className="text-left">Tech and non-tech roles</p>
                <p className="">{
                    totalParticipating} candidates participating
                </p>
            </div>
        </div>
      </div>
    </button>
  )
}

export default DriveCustomCard
